import React, { Children } from 'react';
import { motion } from 'framer-motion';
const personas = ['The organized bride', 'The minimalist aesthetic lover', 'The detail-oriented planner', 'The woman who wants elegance without clutter'];
export function ForWhoSection() {
  return <section className="w-full bg-[#FDFAF6] py-24 px-6 md:py-32" data-id="element-96">
      <div className="max-w-5xl mx-auto text-center" data-id="element-97">
        <span className="text-xs uppercase tracking-[0.2em] text-[#8FAF88] font-medium block mb-6" data-id="element-98">
          Who It's For
        </span>
        <h2 className="text-4xl md:text-5xl font-light text-[#2C2C2C] mb-16" data-id="element-99">
          Designed for the Bride Who <br data-id="element-100" />
          <span className="italic" data-id="element-101">Values Structure</span>
        </h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.1
          }
        }
      }} data-id="element-102">
          {personas.map((persona, index) => <motion.div key={index} variants={{
          hidden: {
            opacity: 0,
            scale: 0.95
          },
          visible: {
            opacity: 1,
            scale: 1
          }
        }} className="flex items-center justify-center space-x-4 p-6 bg-white/50 border border-[#EEF3ED]" data-id="element-103">
              {/* Simple Leaf Icon SVG */}
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8FAF88" strokeWidth="1.5" className="flex-shrink-0" data-id="element-104">
                <path d="M12 22C12 22 20 18 20 12C20 6 12 2 12 2C12 2 4 6 4 12C4 18 12 22 12 22Z" data-id="element-105" />
                <path d="M12 22V12" data-id="element-106" />
                <path d="M12 12L16 8" data-id="element-107" />
                <path d="M12 12L8 8" data-id="element-108" />
              </svg>
              <span className="text-xl font-serif italic text-[#2C2C2C]" data-id="element-109">
                {persona}
              </span>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="mt-16" data-id="element-110">
          <div className="w-12 h-[1px] bg-[#C4A882] opacity-50 mx-auto mb-8" data-id="element-111"></div>
          <p className="text-lg uppercase tracking-widest text-[#2C2C2C] font-light" data-id="element-112">
            If you want your planning process to feel calm and intentional —
            this is for you.
          </p>
        </motion.div>
      </div>
    </section>;
}